/* eslint-disable */
export const generatedEnvironment = {
    "release": "9ce91c6b74"
};
